import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { couponReportFetchApi, couponReportExportApi } from "services/ReportService";
import { dateFormate, handlePermissions } from "utils/utils";
import ReportsTab from "../ReportsTabV2";
import bookingCount from "assets/images/bookingCount.svg";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { requestCouponReportApi } from "services/ReportService";

function Reports() {
  const navigate = useNavigate();
  const role = localStorage.getItem('role');
  
  // State management using useState
  const [value, setValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState(dateFormate(new Date(), "YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(dateFormate(new Date(), "YYYY-MM-DD"));
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  //const [bookingData, setBookingData] = useState({});
  const [isLoadingRideAnalytic, setIsLoadingRideAnalytic] = useState(false);
  const [locValue, setLocValue] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [isRequestingReport, setIsRequestingReport] = useState(false);

  // Keep only necessary Redux selectors for permissions and user profile
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );

  // Filter data object
  const getFilterData = () => ({
    id: "",
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    pageSize: rowsPerPage,
    type: value && value != "" ? value : null,
    status: "",
    tabValue: 'booking',
    location: selectedLocation?.id || locValue?.id,
  });

  const titleData = {
    barTitle: "Booking Split",
    doughnutTitle: "Total No. of Booking",
  };

  // Set default location from user profile
  useEffect(() => {
    if (userProfileData?.Company?.ServiceCity?.id) {
      setLocValue({
        id: userProfileData?.Company?.ServiceCity?.id,
        name: userProfileData?.Company?.ServiceCity?.name,
      });
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  // Fetch data function
  const fetchData = async (filterData) => {
    setLoader(true);
    setIsLoadingRideAnalytic(true);
    try {
      const response = await couponReportFetchApi(filterData);
      if (response.success) {
        
        setTableData(response?.data || []);
        
      }
    } catch (error) {
      setTableData([]);
      
    } finally {
      setLoader(false);
      setIsLoadingRideAnalytic(false);
    }
  };

  // Handle tab change
  const handleChange = (newValue) => {
    setValue(newValue);
    const filterData = {
      ...getFilterData(),
      type: newValue
    };
    fetchData(filterData);
  };

  // Initial data fetch
  useEffect(() => {
    const filterData = {
      ...getFilterData(),
      type: "1",
      location: selectedLocation?.id || locValue?.id
    };
    fetchData(filterData);
  }, [selectedLocation?.id, locValue?.id]);

  // Handle pagination
  const handleChangePage = (newPage) => {
    setPage(newPage);
    const filterData = {
      ...getFilterData(),
      page: newPage
    };
    fetchData(filterData);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    const filterData = {
      ...getFilterData(),
      page: 0,
      pageSize: newRowsPerPage
    };
    fetchData(filterData);
  };

  // Handle table row click
  const onClickTableVendor = (data) => {
    
  };

  // Handle date range selection
  const onSelectDateRange = (newValue) => {
    let newDateFrom = '';
    let newDateTo = '';
    
    if (newValue === null) {
      setDateFrom('');
      setDateTo('');
    } else {
      newDateFrom = dateFormate(newValue[0], "YYYY-MM-DD");
      newDateTo = dateFormate(newValue[1], "YYYY-MM-DD");
      setDateFrom(newDateFrom);
      setDateTo(newDateTo);
    }
    
    const filterData = {
      ...getFilterData(),
      dateFrom: newDateFrom,
      dateTo: newDateTo
    };
    fetchData(filterData);
  };

  // Handle export
  const onExport = async () => {
    setIsExporting(true);
    try {
      const exportFilter = {
        ...getFilterData(),
        export: true,
      };
      const response = await couponReportExportApi(exportFilter);
      if (response.success) {
        // Handle successful export - maybe show a toast message
        toast.success(response.data?.message || "Coupon report generation started. You will receive an email once ready.");
      }
    } catch (error) {
      toast.error("Failed to export coupon report. Please try again later.");
    } finally {
      setIsExporting(false);
    }
  };

  // Handle location input change
  const onInputChange = (data) => {
    setLocValue(data);
    const filterData = {
      ...getFilterData(),
      location: data?.id
    };
    fetchData(filterData);
  };

  // Permission handling
  const reportRoleEnum = roleAndPermissionEnum.reports;

  const accessForall = handlePermissions(
    roleAndPermissions,
    reportRoleEnum.moduleKey,
    { defaultAllAccess: reportRoleEnum?.subModules?.booking?.all }
  );

  const accessForDownload = handlePermissions(
    roleAndPermissions,
    reportRoleEnum.moduleKey,
    { customAccess: reportRoleEnum?.subModules?.booking?.download }
  );

  const hasViewMoreIcon = (accessForall || accessForDownload);

  const onRequestReport = async (format) => {
    setIsRequestingReport(true);
  try {
    const payload = {
      startDate: dateFrom,
      endDate: dateTo,
      reportType: "COUPON",
      reportFormate: format,
      city: selectedLocation?.id || locValue?.id,
      tripType: value
    };
    const response = await requestCouponReportApi(payload);
    if (response.success) {
      toast.success("Report request submitted successfully");
      navigate("/report-generate");
    } else {
      toast.error(response?.message || "Failed to request report");
    }
  } catch (error) {
    toast.error("Error requesting report");
  }
  finally {
    setIsRequestingReport(false);
  }
};

  return (
    <>
      <ReportsTab
        loader={loader}
        handleChange={handleChange}
        value={value}
        titleData={titleData}
        rideTrackData={tableData}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        isLoadingRideAnalytic={isLoadingRideAnalytic}
        rideAnalytic={[]}
        onClickTableVendor={onClickTableVendor}
        isClickable={false}
        countSrc={bookingCount}
        title={'Coupons'}
        exportDataDisplay={true}
        filterDisplay={false}
        onSelectDateRange={onSelectDateRange}
        dateFrom={dateFrom}
        dateTo={dateTo}
        tabName={'rideTrack'}
        onExport={onExport}
        onInputChange={onInputChange}
        role={role}
        userProfileData={userProfileData}
        selectCity={true}
        locValue={locValue}
        hasViewMoreIcon={hasViewMoreIcon}
        isExporting={isExporting}
        onRequestReport={onRequestReport}
        isRequestingReport={isRequestingReport}
      />
    </>
  );
}

export default Reports;